module.exports = __webpack_public_path__ + "static/money-spent-christmas-833c4351c4a52b43e1171f50a650b4ee.png";